<template>
  <div class="app-container">
    <el-card class="search-card" shadow="never">
      <el-form :inline="true" :model="queryParams">
        <el-form-item label="订单编号">
          <el-input v-model="queryParams.orderCode" placeholder="请输入订单编号" clearable @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="queryParams.phone" placeholder="请输入手机号" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="action-card" shadow="never">
      <el-button type="primary" icon="el-icon-upload" @click="handleBatchPush">批量推送</el-button>
      <el-button type="info" plain icon="el-icon-question" @click="handleGuide">操作指引</el-button>
    </el-card>

    <el-card shadow="never">
      <el-table v-loading="loading" :data="reportList" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="订单编号" prop="orderCode" min-width="160" show-overflow-tooltip />
        <el-table-column label="手机号" prop="phone" width="120" />
        <el-table-column label="当前功率 (W)" prop="curPower" width="120" align="center" />
        <el-table-column label="上报时间" prop="reportTime" width="180" />
        <el-table-column label="推送状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="getPushStatusType(scope.row.pushStatus)">
              {{ getPushStatusLabel(scope.row.pushStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="推送时间" prop="pushTime" width="180" />
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handlePush(scope.row)">推送</el-button>
            <el-button size="mini" type="text" @click="handleViewPushLog(scope.row)">推送记录</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-show="total > 0"
        :current-page.sync="queryParams.pageNum"
        :page-size.sync="queryParams.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="getList"
        @current-change="getList"
      />
    </el-card>

    <!-- 推送记录对话框 -->
    <el-dialog title="推送记录" :visible.sync="pushLogOpen" width="900px">
      <el-table :data="pushLogList" border>
        <el-table-column label="推送时间" prop="createdTime" width="180" />
        <el-table-column label="数据类型" prop="dataType" width="100">
          <template slot-scope="scope">
            <el-tag size="mini">{{ getDataTypeLabel(scope.row.dataType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="推送状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.pushStatus === 1 ? 'success' : 'danger'">
              {{ scope.row.pushStatus === 1 ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="接口 URL" prop="interfaceUrl" show-overflow-tooltip />
        <el-table-column label="错误信息" prop="errorMessage" show-overflow-tooltip width="200" />
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleRetryPush(scope.row)">重试</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="pushLogTotal > 0"
        :current-page.sync="pushLogQuery.pageNum"
        :page-size.sync="pushLogQuery.pageSize"
        :page-sizes="[10, 20, 50]"
        :total="pushLogTotal"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="loadPushLog"
        @current-change="loadPushLog"
      />
    </el-dialog>
  </div>
</template>

<script>
import { listChargingReport, delChargingReport, pushChargingReport, batchPushChargingReport, listPushLog, retryPush } from '@/api/coo/chargingReport'

export default {
  name: 'ChargingReport',
  data() {
    return {
      loading: true,
      reportList: [],
      total: 0,
      ids: [],
      multiple: true,
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        orderCode: undefined,
        phone: undefined
      },
      pushLogOpen: false,
      pushLogList: [],
      pushLogTotal: 0,
      pushLogQuery: {
        pageNum: 1,
        pageSize: 10
      },
      currentReport: null
    }
  },
  created() {
    this.getList()
    this.$guide.startGuideIfNeeded('report')
  },
  methods: {
    handleGuide() {
      this.$guide.startGuide('report')
    },
    getList() {
      this.loading = true
      listChargingReport(this.queryParams).then(response => {
        this.reportList = response.data || []
        this.total = response.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 20,
        orderCode: undefined,
        phone: undefined
      }
      this.handleQuery()
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.multiple = !selection.length
    },
    handlePush(row) {
      pushChargingReport(row.id).then(response => {
        if (response.code === 200) {
          this.$message.success(response.message || '推送成功')
          this.getList()
        } else {
          this.$message.error(response.message || '推送失败')
        }
      })
    },
    handleBatchPush() {
      if (this.ids.length === 0) {
        this.$message.warning('请先选择要推送的上报记录')
        return
      }
      this.$confirm('确认推送选中的上报记录吗？', '提示', {
        type: 'warning'
      }).then(() => batchPushChargingReport({ ids: this.ids })).then(response => {
        if (response && response.code === 200) {
          this.$message.success(`批量推送完成，成功 ${response.successCount || 0} 条，失败 ${response.failCount || 0} 条`)
          this.getList()
        } else if (response) {
          this.$message.error(response.message || '批量推送失败')
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该上报记录吗？', '提示', {
        type: 'warning'
      }).then(() => delChargingReport(row.id)).then(response => {
        if (response && response.code === 200) {
          this.$message.success(response.message || '删除成功')
          this.getList()
        } else if (response) {
          this.$message.error(response.message || '删除失败')
        }
      })
    },
    handleViewPushLog(row) {
      this.currentReport = row
      this.pushLogOpen = true
      this.pushLogQuery.pageNum = 1
      this.loadPushLog()
    },
    loadPushLog() {
      if (!this.currentReport) return
      const dataId = this.currentReport.orderCode || this.currentReport.id
      listPushLog({ dataType: 'report', dataId, ...this.pushLogQuery }).then(response => {
        this.pushLogList = response.data || []
        this.pushLogTotal = response.total || 0
      })
    },
    handleRetryPush(log) {
      this.$confirm('确认重新推送这条记录吗？', '提示', {
        type: 'warning'
      }).then(() => retryPush(log.id)).then(response => {
        if (response && response.code === 200) {
          this.$message.success(response.message || '重试成功')
          this.loadPushLog()
          this.getList()
        } else if (response) {
          this.$message.error(response.message || '重试失败')
        }
      })
    },
    getPushStatusType(status) {
      if (status === 1) return 'success'
      if (status === 2) return 'danger'
      return 'info'
    },
    getPushStatusLabel(status) {
      if (status === 1) return '已推送'
      if (status === 2) return '推送失败'
      return '未推送'
    },
    getDataTypeLabel(type) {
      const map = {
        station: '充电站',
        equipment: '设备',
        port: '充电口',
        order: '订单',
        report: '过程上报',
        alarm: '告警'
      }
      return map[type] || type || '-'
    }
  }
}
</script>

<style scoped>
.search-card,
.action-card {
  margin-bottom: 15px;
}
</style>
